<div id="dashboard-wrapper">
  <app-dashboard-panel style="height: 100%"></app-dashboard-panel>
</div>
